import { Details } from "./details.js";
import { InternalApiProvider } from "./internal-api.js";
import { Modal } from "../modal/index.js";
import { Overview } from "./overview.js";
import { Typography } from "@mui/material";
import { useTranslation } from "next-i18next";
import React from "react";
export const ModalPreferences = ({ open }) => {
    const { t } = useTranslation("c-user-consent-management");
    return (React.createElement(Modal, { allowClose: false, dialogProps: {
            fullWidth: true,
            keepMounted: false,
            maxWidth: "md",
            PaperProps: { sx: { background: "white", borderRadius: "16px" } },
            scroll: "paper",
        }, label: t("privacy-policy", "Datenschutz-Einstellungen"), onClose: () => { }, open: open && typeof window !== "undefined" },
        React.createElement(ModalContent, null)));
};
const ModalContent = () => {
    const { t } = useTranslation("c-user-consent-management");
    const [view, setView] = React.useState("overview");
    const changeView = (view) => setView(view);
    return (React.createElement(React.Fragment, null,
        React.createElement(Typography, { component: "div", variant: "h3", sx: { pb: { xs: 3, sm: 6 }, textAlign: { xs: "left", sm: "center" }, width: "100%" } }, t("privacy-headline", "Datenschutz & Kekse")),
        React.createElement(InternalApiProvider, null,
            view === "overview" && React.createElement(Overview, { changeView: changeView }),
            view === "details" && React.createElement(Details, { changeView: changeView }))));
};
//# sourceMappingURL=modal-preferences.js.map